import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { DIENSTKAARTEN, type Dienstkaart } from "../lib/dienstkaarten";
import { PAGE_CONTAINER } from "./site";

const link = "inline-flex items-center gap-1 text-[15px] font-semibold text-[#14213D] underline-offset-4 hover:underline";

function KaartLink({ kaart }: { kaart: Dienstkaart }) {
  if (kaart.url) {
    return (
      <a href={kaart.url} target="_blank" rel="noopener" className={link}>
        Bekijk nu <ChevronRight className="size-4" aria-hidden="true" />
      </a>
    );
  }
  return (
    <Link to="/elektricien/$dienst" params={{ dienst: kaart.dienst ?? "" }} className={link}>
      Bekijk nu <ChevronRight className="size-4" aria-hidden="true" />
    </Link>
  );
}

function Kaart({ kaart }: { kaart: Dienstkaart }) {
  return (
    <li className="flex items-center justify-between gap-4 rounded-[16px] border border-[#E3E6EB] bg-white p-5 md:p-6">
      <div className="min-w-0">
        <h3 className="text-[19px] font-extrabold leading-tight tracking-tight text-[#14213D]">{kaart.titel}</h3>
        <p className="mt-1 text-[15px] leading-[1.45] text-[#4A5468]">{kaart.ondertitel}</p>
        <div className="mt-4">
          <KaartLink kaart={kaart} />
        </div>
      </div>
      {kaart.foto && (
        <img
          src={kaart.foto}
          alt={kaart.alt ?? `${kaart.titel} foto`}
          width={120}
          height={120}
          loading="lazy"
          decoding="async"
          className="size-20 shrink-0 object-contain md:size-24"
        />
      )}
    </li>
  );
}

export function Dienstkaarten() {
  return (
    <section aria-label="Onze diensten" className={`${PAGE_CONTAINER} pt-10`}>
      <ul className="grid list-none gap-4 p-0 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
        {DIENSTKAARTEN.map((kaart) => (
          <Kaart key={kaart.titel} kaart={kaart} />
        ))}
      </ul>
    </section>
  );
}
